import { Injectable } from '@angular/core';
import { CanActivate, NavigationEnd, Router, RouterEvent } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { catchError, filter, map, switchMap, take, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { LocaleService } from '../services/locale.service';
import { ErrorService } from '../services/error.service';

@Injectable()
export class FacebookAuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private localeService: LocaleService,
    private errorService: ErrorService
  ) {}

  canActivate() {
    return this.authService.facebookAuthData$.pipe(
      filter(res => !!res),
      take(1),
      switchMap(res => {
        if (res.code && res.state) {
          return this.authService.getUserCountryCode().pipe(
            catchError(err => {
              this.errorService.captureError(err);
              return of('');
            }),
            switchMap((regCountry: string) =>
              this.authService.checkLoginWithFacebook({
                ...res,
                data: {
                  locale: this.localeService.locale,
                  utm: this.authService.getUtm(),
                  ai_fb_sign_up: true,
                  reg_country: regCountry
                }
              })
            ),
            tap(() =>
              this.router.events
                .pipe(
                  filter(
                    (event: RouterEvent) =>
                      event instanceof NavigationEnd && event.urlAfterRedirects === '/home'
                  ),
                  switchMap(() => this.authService.client$.pipe(filter(client => !!client))),
                  take(1)
                )
                .subscribe()
            ),
            map(res => !!res)
          );
        } else {
          return of(false);
        }
      }),
      catchError(error => {
        this.authService.logout(false);
        this.errorService.captureError(error);

        return of(false);
      }),
      tap(res => {
        if (res) {
          this.router.navigate(['']);
        }
      }),
      map(res => !res)
    );
  }
}
